import React, { useState, useEffect } from 'react';
import styles from './index.module.scss';
import axios from 'axios';

// importa componente
import useIsMounted from 'ismounted';
import { useSelector } from 'react-redux';
import { useHistory, useParams } from "react-router-dom";
import { Button, Card, Row, Col, Form } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ConteudoEmail from './../ConteudoEmail';
import ContentEditable from "react-contenteditable";
import Tags from './../../../Componentes/Tags';

// componente
export default function Cadastrar({
    // modoLeitura='modelo' // modelo, envio
}){

    // carregar template base
    const isMounted = useIsMounted();
    let history = useHistory();
    let {id} = useParams();
    let login = useSelector(state => state.login);
    let [html, alterarHtml] = useState('');
    let [htmlDestaque, alterarHtmlDestaque] = useState('');
    let [modo, alterarModo] = useState('cadastro'); // cadastro, edicao
    let [carregando, alterarCarregando] = useState(true);
    let [dados, alterarDados] = useState({
        id: id || null,
        descricao: null,
        titulo: null,
        destaque: null,
        conteudo: null,
        id_imagem: null
    });
    let [padraoAntigo, alterarPadraoAntigo] = useState(false);
    let [salvando, alterarSalvando] = useState(false);


    // tera outro componente para envio de email

    // opção para pré visualização deverá ser carregada a partir do backend
    
    // não terá rodapé no front (somente pré visualização e em caso de reenvio)

    // verificar todas as funções de envio de email para unificar, detaque, conteudo, cabeçalho e rodapé(assinatura)

    // inicializa componente
    useEffect(() => {

        // verifica se é edição
        if(dados.id){

            // altera o modo
            alterarModo('edicao');

            // carrega os dados do modelo de email
            axios.get(`/modelosEmail/${dados.id}`)
            .then(({data, ...retorno}) => {
                alterarDados(data.dados);
            })
            .catch(() => {})
            .then(() => {
                alterarCarregando(false);
            })

        }else{
            alterarCarregando(false);
        }

    }, []);

    // salva
    function salvar(){
        alterarSalvando(true);

        // salva
        axios.post(`modelosEmail`, dados)
        .then(({data, ...retorno}) => {
            history.push('/painel/modelos-email');
        })
        .catch(() => {})
        .then(() => {
            if(isMounted.current){
                alterarSalvando(false);
            }
        });

    }

    // carregando
    if(carregando){
        return <div>Carregando...</div>
    }

    return <>
        <Row>
            <Col md='8'>
                <Card className='border-0 shadow-sm'>
                    <Card.Header className='bg-white border-0 mb-0 pb-0'>
                        <Card.Title>Cadastro Modelo de Email</Card.Title>
                    </Card.Header>
                    <Card.Body>
                        <Form.Group>
                            <Form.Label>Descrição</Form.Label>
                            <Form.Control 
                                value={dados.descricao || ''}
                                onChange={e => {
                                    dados.descricao = e.target.value;
                                    alterarDados({...dados});
                                }}
                            />
                        </Form.Group>

                    </Card.Body>
                </Card>
            </Col>
            <Col md='4'></Col>
        </Row>
        <Row>
            <Col md='8'>

                <Card className='border-0 shadow-sm mt-4'>
                    <Card.Body
                        className={padraoAntigo && 'p-0'}
                        style={{
                            overflowX: padraoAntigo ? 'auto' : null
                        }}
                    >
                        <ConteudoEmail 
                            value={{
                                id_imagem: dados.id_imagem,
                                titulo: dados.titulo,
                                destaque: dados.destaque,
                                conteudo: dados.conteudo
                            }}
                            onChange={dadosNovos => {
                                Object.assign(dados, dadosNovos);
                                alterarDados({...dados});
                            }}
                        />
                    </Card.Body>
                </Card>
            </Col>
            <Col>
                <Card className='border-0 shadow-sm mt-4'>
                    <Card.Header className='mb-0 border-0 bg-white pb-0'>
                        <Card.Title className='mb-0' as='h5'>Tags</Card.Title>
                    </Card.Header>
                    <Card.Body>
                        {/* {[
                            {descricao: 'Nome', id: '[CL_NOME]'},
                            {descricao: 'Primeiro Nome', id: '[CL_PRIMEIRO_NOME]'},
                            {descricao: 'Nome Pai', id: '[CL_NOME_PAI]'},
                            {descricao: 'Nome Mãe', id: '[CL_NOME_MAE]'},
                            {descricao: 'Estado Civil', id: '[CL_ESTADO_CIVIL]'},
                            {descricao: 'Profissão', id: '[CL_PROFISSAO]'},
                            {descricao: 'CPF', id: '[CL_CPF]'},
                            {descricao: 'RG', id: '[CL_RG]'},
                            {descricao: 'Data de Emissão RG', id: '[CL_RG_DATA_EMISSAO]'},
                            {descricao: 'CNH', id: '[CL_CNH]'},
                            {descricao: 'Data de emissão CNH', id: '[CL_CNH_DATA_EMISSAO]'},
                            {descricao: 'Data de Nascimento', id: '[CL_DATA_NASCIMENTO]'},
                            {descricao: 'Telefone Residencial', id: '[CL_TELEFONE_RESIDENCIAL]'},
                            {descricao: 'Telefone Comercial', id: '[CL_TELEFONE_COMERCIAL]'},
                            {descricao: 'Telefone Celular', id: '[CL_TELEFONE_CELULAR]'},
                            {descricao: 'Email', id: '[CL_EMAIL]'},
                            {descricao: 'Nome Fantasia', id: '[CL_NOME_FANTASIA]'},
                            {descricao: 'Juridico - Nome Responsável', id: '[CL_RESPONSAVEL_JURIDICO_NOME]'},
                            {descricao: 'Juridico - Telefone Responsável', id: '[CL_RESPONSAVEL_JURIDICO_TELEFONE]'},
                            {descricao: 'CNPJ', id: '[CL_CNPJ]'},
                            {descricao: 'Juridico - Email Responsável', id: '[CL_RESPONSAVEL_JURIDICO_EMAIL]'},
                            {descricao: 'Site', id: '[CL_SITE]'},
                            {descricao: 'CEP', id: '[CL_CEP]'},
                            {descricao: 'Cidade', id: '[CL_CIDADE]'},
                            {descricao: 'Estado', id: '[CL_ESTADO]'},
                            {descricao: 'Endereço', id: '[CL_ENDERECO]'},
                            {descricao: 'Número', id: '[CL_NUMERO]'},
                            {descricao: 'Bairro', id: '[CL_BAIRRO]'},
                            {descricao: 'Complemento', id: '[CL_COMPLEMENTO]'},

                        ].map(opcao => 
                            <BotaoTag 
                                key={opcao.id} 
                                value={opcao.descricao}
                                onMouseDown={e => {
                                    document.execCommand('insertText', false, opcao.id);
                                }}
                            />    
                        )} */}
                        <Tags />
                    </Card.Body>
                </Card>
            </Col>
        </Row>
        <Row>
            <Col md='8'>
                <SalvarFormulario 
                    salvando={salvando}
                    onClick={() => salvar()}
                    cancelar={() => {
                        history.push('/painel/modelos-email');
                    }}
                />
            </Col>
        </Row>
    </>
}


function SalvarFormulario({
    salvando,
    cancelar,
    onClick
}){
    return <Form.Group className="d-flex justify-content-around my-4">
        <Button variant="danger" onClick={cancelar}>Cancelar</Button>
        <Button variant="success" disabled={salvando} onClick={onClick}>
            {salvando ? 
                <>
                    <FontAwesomeIcon className="icone" pulse icon={["fas", 'spinner']} />
                    <span>Salvando</span>
                </> : 
                <span>Salvar</span>
            }
        </Button>
    </Form.Group>
}